import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";

function ELFI2024() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>Extension of ColorTransferLab: A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms</BlockTitle>
          <BlockSubtitle>European Light Field Imaging Workshop, Sozopol, Bulgaria, Jun. 25 - 27, 2024.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Abstract</BlockSubtitle>
            <BlockText>The algorithmic approach of color transfer seeks to modify the color statistics of a source object to match those of a reference object. These objects can include images, videos, 3D meshes, and 3D point clouds. Over the past decades, the development of numerous methods and the shortage of available implementations have made it difficult to select and apply the appropriate approach for specific needs. To address this issue, various test beds have been developed. This paper enhances one such test beds: The ColorTransferLab, a web-based platform that aggregates multiple color transfer algorithms for simple testing and evaluation. Initially, this test bed was limited to desktop interfaces and applicable only to images, 3D meshes, and 3D point clouds. With this publication, we introduce a mobile version of this tool, capable of extending color transfer to videos and volumetric videos. This enhancement broadens the applicability to a wider range of objects and simplifies user interaction.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://potechius.com/Downloads/Publications/potechius_elfi2024_extension-of-colortransferlab.pdf")}>Paper</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://potechius.com/Downloads/Publications/potechius_elfi2024_extension-of-colortransferlab.pdf")}>arXiv</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default ELFI2024;
